// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const GOOGLE_VERTEX_MODELS = {
	"gemini-2.5-flash": {
		id: "gemini-2.5-flash",
		name: "Gemini 2.5 Flash",
		api: "google-vertex",
		provider: "google-vertex",
		baseUrl: "https://{location}-aiplatform.googleapis.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.3,
			output: 2.5,
			cacheRead: 0.03,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-vertex">,
	"gemini-2.5-flash-lite": {
		id: "gemini-2.5-flash-lite",
		name: "Gemini 2.5 Flash-Lite",
		api: "google-vertex",
		provider: "google-vertex",
		baseUrl: "https://{location}-aiplatform.googleapis.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.1,
			output: 0.4,
			cacheRead: 0.01,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-vertex">,
	"gemini-2.5-pro": {
		id: "gemini-2.5-pro",
		name: "Gemini 2.5 Pro",
		api: "google-vertex",
		provider: "google-vertex",
		baseUrl: "https://{location}-aiplatform.googleapis.com",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-vertex">,
	"gemini-3-flash-preview": {
		id: "gemini-3-flash-preview",
		name: "Gemini 3 Flash Preview",
		api: "google-vertex",
		provider: "google-vertex",
		baseUrl: "https://{location}-aiplatform.googleapis.com",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 0.5,
			output: 3,
			cacheRead: 0.05,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-vertex">,
	"gemini-3.1-flash-lite": {
		id: "gemini-3.1-flash-lite",
		name: "Gemini 3.1 Flash Lite",
		api: "google-vertex",
		provider: "google-vertex",
		baseUrl: "https://{location}-aiplatform.googleapis.com",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 1.5,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-vertex">,
	"gemini-3.1-pro-preview": {
		id: "gemini-3.1-pro-preview",
		name: "Gemini 3.1 Pro Preview",
		api: "google-vertex",
		provider: "google-vertex",
		baseUrl: "https://{location}-aiplatform.googleapis.com",
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":null,"low":"LOW","medium":null,"high":"HIGH"},
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 12,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-vertex">,
	"gemini-3.1-pro-preview-customtools": {
		id: "gemini-3.1-pro-preview-customtools",
		name: "Gemini 3.1 Pro Preview Custom Tools",
		api: "google-vertex",
		provider: "google-vertex",
		baseUrl: "https://{location}-aiplatform.googleapis.com",
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":null,"low":"LOW","medium":null,"high":"HIGH"},
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 12,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-vertex">,
	"gemini-3.5-flash": {
		id: "gemini-3.5-flash",
		name: "Gemini 3.5 Flash",
		api: "google-vertex",
		provider: "google-vertex",
		baseUrl: "https://{location}-aiplatform.googleapis.com",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 1.5,
			output: 9,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-vertex">,
	"gemini-flash-latest": {
		id: "gemini-flash-latest",
		name: "Gemini Flash Latest",
		api: "google-vertex",
		provider: "google-vertex",
		baseUrl: "https://{location}-aiplatform.googleapis.com",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 1.5,
			output: 9,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-vertex">,
	"gemini-flash-lite-latest": {
		id: "gemini-flash-lite-latest",
		name: "Gemini Flash-Lite Latest",
		api: "google-vertex",
		provider: "google-vertex",
		baseUrl: "https://{location}-aiplatform.googleapis.com",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 1.5,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 1048576,
		maxTokens: 65536,
	} satisfies Model<"google-vertex">,
} as const;
